import useSetRemoteFormState from '@hooks/useSetRemoteFormState';

import { defaultValues } from '../constants';

/**
 * Clears only the mobile-specific fields from the shared remote FORM_STATE
 * while preserving all other form data (energy, broadband, address, etc.).
 *
 * This is needed because FormSync's useSyncFormField hydrates empty forms
 * with stale remote state on page load. Without clearing, adding a new SIM
 * after editing would incorrectly populate the form with the previous SIM's
 * data from remote state, preventing the correct add-mode initial values
 * from being applied.
 */
const useResetMobileRemoteFormState = () => {
  return useSetRemoteFormState(defaultValues);
};

export { useResetMobileRemoteFormState };
